import { render } from "./TemplatesCreate.vue?vue&type=template&id=13f28f35"
import script from "./TemplatesCreate.vue?vue&type=script&lang=js"
export * from "./TemplatesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__